import { graphql } from 'gql.tada';

export const GET_CATEGORIES = graphql(`
    query GetCategories($contentType: ContentType!) {
        categories(contentType: $contentType) {
            id
            title
            catchPhrase
            image
        }
    } 
`);
